/** Özel kod bölümünün alan tanımları ve değişiklik ölçüsü.
 *
 * Parçalar `settings` kaydında **değildir**: kendi tablosundadır ve kendi
 * ucundan yazılır (`PUT /admin/custom-code`; bkz.
 * `backend/services/custom_code.py`). CSS ve JS tarayıcıya ayrı birer dosya
 * olarak servis edilir, satır içi üç slot ise belgeye ham HTML olarak basılır.
 *
 * Tanımlar burada durur çünkü **üç yer birden** okur: alanları çizen bölüm,
 * Kaydet düğmesinin görünürlüğü ve gönderilen gövde. Ayrışırlarsa yöneticinin
 * yazdığı alan kaydedilmeden "Kaydedildi" yazardı.
 */

export const CUSTOM_CODE_SLOTS = [
  {
    key: 'css',
    title: 'CSS',
    kind: 'asset',
    language: 'css',
    hint: 'Sitenin en sonunda yüklenir, yani tema stillerini ezebilir. '
      + '<style> etiketi yazmayın — dosya olarak servis edilir.',
    placeholder: '/* Örnek: üst menünün altına altın bir çizgi */\n'
      + '#bhs-header { border-bottom: 2px solid var(--pusu-gold); }',
  },
  {
    key: 'js',
    title: 'JavaScript',
    kind: 'asset',
    language: 'javascript',
    hint: 'Sayfa çizildikten sonra çalışır (defer). <script> etiketi '
      + 'yazmayın — dosya olarak servis edilir.',
    placeholder: "// Örnek\ndocument.querySelectorAll('[data-bhs=\"game-card\"]').length;",
  },
  {
    key: 'header',
    title: 'Header kodu (HTML)',
    kind: 'inline',
    language: 'html',
    hint: '</head> etiketinden hemen önce çalışır. Doğrulama etiketleri, '
      + 'yazı tipi ve izleme kodları buraya.',
    placeholder: '<script>\n  // İzleme veya doğrulama kodu\n</script>',
  },
  {
    key: 'body',
    title: 'Body kodu (HTML)',
    kind: 'inline',
    language: 'html',
    hint: '<body> açılışından hemen sonra çalışır. Sayfa çizilmeden '
      + 'çalışması gereken kodlar buraya.',
    placeholder: '<!-- Body açılışından hemen sonra çalışacak kod -->',
  },
  {
    key: 'footer',
    title: 'Footer kodu (HTML)',
    kind: 'inline',
    language: 'html',
    hint: '</body> etiketinden hemen önce çalışır. Canlı destek gibi widget '
      + 'kodlarının olağan yeri burasıdır.',
    placeholder: '<!-- Sayfanın sonunda çalışacak kod -->',
  },
];

export const CUSTOM_CODE_KEYS = CUSTOM_CODE_SLOTS.map((slot) => slot.key);

export const EMPTY_CUSTOM_CODE = CUSTOM_CODE_KEYS.reduce(
  (acc, key) => ({ ...acc, [key]: '' }), {},
);

/** Uç yanıtından panelin düzenlediği metin sözlüğünü çıkarır. */
export const codeFromResponse = (data) => CUSTOM_CODE_KEYS.reduce((acc, key) => ({
  ...acc,
  [key]: data?.slots?.[key]?.content || '',
}), {});

/** Uç yanıtından slot üstbilgilerini (sürüm, adres, kaydeden) çıkarır. */
export const metaFromResponse = (data) => CUSTOM_CODE_KEYS.reduce((acc, key) => ({
  ...acc,
  [key]: data?.slots?.[key] || null,
}), {});

/** Yalnızca gerçekten değişen slotlar.
 *
 * Tam gövde göndermek zararsız olurdu (uç değişmeyen slotu atlar) ama gövde
 * beş parçanın tamamını taşır ve büyük bir stil dosyasını her kayıtta
 * yeniden yüklemek gereksizdir.
 */
export const changedFields = (current, initial) => CUSTOM_CODE_KEYS.reduce((acc, key) => {
  const next = String(current?.[key] ?? '');
  if (next === String(initial?.[key] ?? '')) return acc;
  return { ...acc, [key]: next };
}, {});

export const dirtyKeys = (current, initial) => Object.keys(changedFields(current, initial));
